export const formatMobileNumber = (countryCode, mobileNumber) => {
  if (
    mobileNumber &&
    mobileNumber.length === 10 &&
    mobileNumber.charAt(0) === "0"
  ) {
    mobileNumber = mobileNumber.replace("0", "");
    const mobileWithCode = countryCode + mobileNumber;
    return mobileWithCode;
  }
  const mobileWithCode = countryCode + mobileNumber;
  return mobileWithCode;
};
